// Styles
import './product-recommendations.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductRecommendations = (context) => {
  const productRecommendationsSection = context.closest('.shopify-section');
  if (!productRecommendationsSection) return;

  if (typeof (window.dAgency.initCarouselBanner) !== 'undefined') {
    window.dAgency.initCarouselBanner(context);
  }

  if (typeof (window.dAgency.initProductTile) !== 'undefined') {
    const productTiles = productRecommendationsSection.querySelectorAll('.product-tile__container');
    if (productTiles.length > 0) {
      productTiles.forEach(tile => {
        window.dAgency.initProductTile(tile);
      });
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-recommendations__container'), (el) => {
    window.dAgency.initProductRecommendations(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-recommendations__container'), (el) => {
      window.dAgency.initProductRecommendations(el);
    });
  });
}
